import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643fd156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currency-input-and-label" }

import { onMounted, ref, computed, PropType } from 'vue';
import { DxNumberBox, DxButton } from 'devextreme-vue/number-box';
import VueDxButton from 'devextreme-vue/button';
import { getCurrencyFormat } from '@/utils/CurrencyFormatter'
import { useCurrentUserStore } from '../../../stores/CurrentUserStore';
import { CurrentUser } from '@/types/user/CurrentUser';
import { FieldSize } from '@/enums/system/FieldSize';
import { FieldValidation } from 'acquaint-api/validation/FieldValidation';
import { ValidatedEvent } from 'devextreme/ui/validator';
import { DxValidator } from 'devextreme-vue';
import { validationCallback } from '@/utils/validation/FieldValidator';
import { DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { TextboxValueChangeEvent } from '@/enums/ui/inputs/TextboxValueChangeEvent';


export default /*#__PURE__*/_defineComponent({
  __name: 'currency-input',
  props: {
    /** 
     * The label displayed for the control.
     * @type {string}
     * @default ''
     */
    label: {
        type: String,
        default: ''
    },
    /** 
     * The numeric value used with `v-model` to bind the component state. 
     * This typically represents an ID or a selected value.
     * @type {number}
     * @required
     */
    modelValue: {
        type: Number,
        required: true
    },
    /** 
     * The minimum allowed numeric value.
     * @type {number}
     * @default 0
     */
    minValue: {
        type: Number,
        default: 0
    },
    /** 
     * The maximum allowed numeric value.
     * @type {number | undefined}
     * @default undefined
     */
    maxValue: {
        type: Number,
        default: undefined
    },
    /** 
     * The width of the component, defined by the `FieldSize` enum.
     * @type {FieldSize}
     * @default FieldSize.Full
     */
    width: {
        type: String as PropType<FieldSize>,
        default: FieldSize.Full
    },
    /** 
     * Determines whether the control is read-only.
     * @type {boolean}
     * @default false
     */
    readOnly: {
        type: Boolean,
        default: false
    },
    /** 
     * The validation rules for the input field.
     * @type {FieldValidation | undefined}
     */
    fieldValidation: {
        type: Object as PropType<FieldValidation>,
        required: false
    },
    /** 
     * A custom validation function for the input field.
     * @type {Function | undefined}
     */
    customValidation: {
        type: Function,
        required: false
    },
    /** 
     * A message to display when the field is invalid.
     * @type {string | undefined}
     */
    invalidMessage: {
        type: String,
        required: false
    },
    /** 
     * The icon associated with the input field.
     * @type {string}
     * @default ''
     */
    icon: {
        type: String,
        default: ''
    },
    /** 
     * The event type that triggers a value change.
     * @type {TextboxValueChangeEvent}
     * @default TextboxValueChangeEvent.Change
     */
    valueChangeEvent: {
        type: String as PropType<TextboxValueChangeEvent>,
        default: TextboxValueChangeEvent.Change
    },
    /** 
     * Determines whether to display button.
     * @type {boolean}
     * @default false
     */
    showButton: {
        type: Boolean,
        default: false
    },
    /** 
     * The button text.
     * @type {string}
     * @required false
     */
    buttonText: {
        type: String,
        required: false
    }
},
  emits: [
    /** 
     * Triggered when the `modelValue` changes. 
     * Used to update the v-model variable in the parent component, typically to reflect the current value.
     * @event update:modelValue
     * @property {number} value - The new value assigned to modelValue.
     */
    'update:modelValue',

    /** 
     * Triggered when the component is clicked. 
     * This event can be used to handle user interactions or trigger actions in the parent component.
     * @event iconClicked
     */
    'iconClicked',
    /** 
     * Triggered when the button is clicked. 
     * This event can be used to handle user interactions or trigger actions in the parent component.
     * @event buttonClicked
     */
    'buttonClicked'
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "346a25b3": (props.width)
}))

const currentUser = ref<CurrentUser>()
const currentUserStore = useCurrentUserStore();
const countryCodeID = ref<number>();
const validationErrors = ref('');
const isValid = ref(true);




onMounted(async () => {
    // Get Current User details from the Current User store
    currentUser.value = await currentUserStore.getCurrentUserDetails()

    // Retrieve the Country Code ID to use for Formatting the Currency
    countryCodeID.value = currentUser.value?.countryCodeID
});



const numberValue = computed({
    get: () => props.modelValue,
    set: (value: number) => emit('update:modelValue', value)
});

/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
    getValue: () => {
        return numberValue.value;
    },
    applyValidationResults: (e: ValidatedEvent) => {
        isValid.value = !!e.isValid;

        // Construct list of validation errors to be displayed to the user when they hover over the field
        validationErrors.value = !e.isValid && e.brokenRule?.message ? e.brokenRule.message : '';
    },
    validationRequestsCallbacks: [],
};

const requiredMessage = computed(() => props.label ? `${props.label} is required` : 'This field is required');

const onIconClicked = () => emit('iconClicked');
const onButtonClicked = () => emit('buttonClicked');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(props.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass(__props.showButton ? 'number-box-container' : 'number-box')
    }, [
      _createVNode(_unref(DxNumberBox), {
        format: _unref(getCurrencyFormat)(countryCodeID.value),
        min: __props.minValue,
        max: __props.maxValue,
        value: numberValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((numberValue).value = $event)),
        width: __props.showButton ? '9.5rem' : 'props.width',
        readOnly: props.readOnly,
        isValid: isValid.value,
        "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => ((isValid).value = $event)),
        hint: validationErrors.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxValidator), { adapter: adapterConfig }, {
            default: _withCtx(() => [
              (__props.fieldValidation?.isRequired)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), {
                    key: 0,
                    message: requiredMessage.value
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (props.customValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 1,
                    reevaluate: true,
                    "validation-callback": __props.customValidation,
                    message: props.invalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true),
              (__props.fieldValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 2,
                    fieldValidation: __props.fieldValidation,
                    "validation-callback": _unref(validationCallback),
                    reevaluate: true
                  }, null, 8, ["fieldValidation", "validation-callback"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(DxButton), {
            name: "info-box-icon",
            position: "after",
            options: { icon: __props.icon, stylingMode: 'text', type: 'dx-dropdowneditor-button', disabled: false, visible: __props.icon, onClick: onIconClicked }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["format", "min", "max", "value", "width", "readOnly", "isValid", "hint"]),
      _createVNode(_unref(VueDxButton), {
        class: "full-width-button",
        text: __props.buttonText,
        name: "currency-input-button",
        position: "after",
        type: "default",
        visible: __props.showButton,
        onClick: onButtonClicked
      }, null, 8, ["text", "visible"])
    ], 2)
  ]))
}
}

})